import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

const shortDay = (d) => new Date(`${d}T00:00:00Z`).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" });

export function TrendChart({ data, bars, height = 220, testId }) {
  return (
    <div style={{ height }} className="w-full" data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
          <XAxis dataKey="day" tickFormatter={shortDay} tick={{ fontSize: 11, fill: "#64748B" }} minTickGap={12} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#64748B" }} />
          <Tooltip labelFormatter={shortDay} contentStyle={{ fontSize: 12, borderRadius: 6 }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {bars.map((b) => <Bar key={b.key} dataKey={b.key} name={b.label} fill={b.color} radius={[3, 3, 0, 0]} />)}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function PeriodToggle({ value, onChange, prefix }) {
  return (
    <div className="inline-flex rounded-md border border-slate-200 p-0.5" role="group" aria-label="Time period">
      {[7, 30].map((d) => (
        <button key={d} type="button" onClick={() => onChange(d)} data-testid={`${prefix}-period-${d}`}
          className={`rounded px-3 py-1 text-sm transition-colors ${value === d ? "bg-[#0A2540] text-white" : "text-slate-600 hover:bg-slate-100"}`}>
          {d} days
        </button>
      ))}
    </div>
  );
}

export function Metric({ label, value, hint, testId }) {
  return (
    <div className="rounded-md border border-slate-200 bg-white p-3" data-testid={testId}>
      <p className="text-xl font-bold text-slate-900">{value}</p>
      <p className="text-xs font-medium text-slate-600">{label}</p>
      {hint && <p className="mt-0.5 text-[11px] leading-snug text-slate-400">{hint}</p>}
    </div>
  );
}

export const VISIT_BARS = [
  { key: "visits", label: "Page visits", color: "#0A2540" },
  { key: "qr_visits", label: "From QR (part of visits)", color: "#0D9488" },
];
